<template>
  <div>
    <b-row>
      <b-col>
        <label>Призвіще</label>
        <b-form-input :disabled="readOnlyInputs" v-model="clientInfo.surname">
        </b-form-input>
      </b-col>
      <b-col>
        <label>Ім'я</label>
        <b-form-input :disabled="readOnlyInputs" v-model="clientInfo.name">
        </b-form-input>
      </b-col>
    </b-row>
    <b-row>
      <b-col class="mt-2">
        <label>Номер карти</label>
        <b-form-input
          :disabled="readOnlyInputs"
          v-model="clientInfo.cardnumber"
        >
        </b-form-input>
      </b-col>
      <b-col class="mt-2">
        <label>Номер телефону</label>
        <b-form-input :disabled="readOnlyInputs" v-model="clientInfo.phonenum">
        </b-form-input>
      </b-col>
    </b-row>
    <b-row>
      <b-col class="mt-2">
        <label>Дата народження</label>
        <b-form-input :disabled="readOnlyInputs" v-model="clientInfo.birthday">
        </b-form-input>
      </b-col>
    </b-row>
    <b-row v-if="trainers.length">
      <b-col class="mt-2">
        <label
          >Тренер
          <assign-trainer
            v-bind:client="clientData"
            v-on:refresh="refreshClient"
        /></label>
        <b-form-input disabled v-model="trainerName"> </b-form-input>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import AssignTrainer from "@/components/ClientPage/modals/AssignTrainer";

export default {
  name: "ClientInfoInputs",
  props: {
    clientData: Object,
    readOnlyInputs: Boolean,
  },
  components: {
    AssignTrainer,
  },
  data: function () {
    return {
      clientInfo: {},
      trainers: [],
    };
  },
  computed: {
    trainerName: function () {
      console.log(this.clientData.trainer);
      if (!this.clientData.trainer) return "";
      if (isNaN(this.clientData.trainer)) return this.clientData.trainer;
      let trainer = this.trainers.find(
        (ele) => ele.id === this.clientData.trainer,
      );
      if (!trainer) return "Немає";
      return trainer.name + " " + trainer.surname;
    },
  },
  async mounted() {
    await this.getTrainers();
  },
  watch: {
    readOnlyInputs: async function (newVal) {
      if (newVal) {
        if (
          JSON.stringify(this.clientData) === JSON.stringify(this.clientInfo)
        ) {
          return;
        }
        await this.patchClient();
      }
    },
    clientData: function () {
      this.clientInfo = JSON.parse(JSON.stringify(this.clientData));
    },
  },
  methods: {
    async patchClient() {
      let payload = {
        client_id: this.clientInfo.id,
        name: this.clientInfo.name,
        surname: this.clientInfo.surname,
        cardnumber: this.clientInfo.cardnumber,
        phonenum: this.clientInfo.phonenum,
        birthday: this.clientInfo.birthday,
        gender: this.clientInfo.gender,
      };
      let response = await this.$api.clients.patchClient(payload);
      if (response.data) {
        this.$emit("refresh");
        this.$emit("showAlert", "Інформація успішно відредагована", "green");
      }
    },
    async getTrainers() {
      let response = await this.$api.trainers.getTrainersList();
      this.trainers = response.data;
    },
    refreshClient() {
      this.$emit("refresh");
    },
  },
};
</script>

<style scoped></style>
